<template>
  <div class="outer-wrapper">
    <div class="inner-page animate__animated animate__slideInRight">
      <b-container fluid>
        <b-form @submit.prevent="updateMeeting">
          <h1 class="title mb-3">Update Meeting</h1>
          <div class="card">
            <div class="card-body p-2">
              <div class="form-group p-2 mb-1">
                <label for="firmName">Broker<span class="text-danger">*</span></label>
                    <multiselect v-model="update_meeting.lead_uuid" :searchable="true" :disabled="true" class="form-multiselect" :placeholder="propertyNoInput"
                    label="full_name" track-by="uuid" :options="brokerList"
                    :taggable="true" @search-change="suggestBroker"></multiselect>
              </div>

              <div class="form-group p-2 mb-1">
                <label for="firmName">Meeting Date<span class="text-danger">*</span></label>
                  <input
                  type="datetime-local"
                  disabled
                  class="form-control"
                  placeholder="Meeting Date"
                  required
                  ref="empanelmentdate"
                  v-model="update_meeting.date"
                />
              </div>
              <div class="form-group p-2 mb-1">
                <CanmeraImageCapture ref="cameraCapture"/>
            </div>
            <div class="form-group p-2 mb-1">
                <label>My Location<span class="text-danger">*</span></label>
                <b-form-input type="text" v-model="update_meeting.location" readonly required placeholder="Find My Location"></b-form-input>
            </div>
              <div class="form-group p-2 mb-1">
                <label for="firmName">Meeting Questionare</label>
                <input type="file" id="myFile" name="filename" @change="uploadQuestionare">
              </div>
            <div class="form-group p-2 mb-1">
              <label for="Comment">Comment</label>
                <textarea
                  type="text"
                  class="form-control"
                  placeholder="Enter Comment"
                  ref="Comment"
                  rows="3"
                  v-model="update_meeting.comment"
                ></textarea>
            </div>
            </div>
          </div>
          <div class="card">
            <div class="form-group m-0">
              <button type="submit"  class="btn btn-primary btn-block">
                Save
              </button>
            </div>
          </div>
        </b-form>
      </b-container>
    </div>
  </div>
</template>
<script>
import { decodeMeetingParams } from '@/assets/scripts/utility.js';
import Multiselect from 'vue-multiselect';
import { required, minLength, maxLength, email} from 'vuelidate/lib/validators';
import { validationMessage } from 'vuelidate-messages'
const formMessages = {
  required: () => 'Field is required',
  txtMinLen: ({ $params }) => `Must be at least ${$params.txtMinLen.min} characters.`,
  txtMaxLen: ({ $params }) => `Must be at most ${$params.txtMaxLen.max} characters.`,
  email: () => 'Should be valid email',
}

export default {
  components: {
    Multiselect,
    CanmeraImageCapture: () => import('@/components/Forms/CameraImageCapture.vue')
  },
  name: "NewMeeting",
  data: () => {
    return {
      brokerList: [],
      update_meeting: {
      },
      meeting_questionare: null,
      propertyNoInput: null,
    };
  },
  validations: {
    lead: {
      full_name: {
        required
      },
      firm_name: {
        required
      },
      primary_phone: {
        required,
        txtMinLen: minLength(8),
        txtMaxLen: maxLength(15)
      },
      primery_email: {
        email
      }
    },
    selectedStatus: {
      required
    },
  },
  created() {
    this.$axios.get(`/meetings/${this.$route.params.uuid}`)
    .then(res => {
        this.update_meeting = res.data.meeting
        this.update_meeting.date = this.update_meeting.meeting_date_formatted
        if (this.update_meeting.lead_uuid) {
          this.update_meeting.lead_uuid = {uuid: this.update_meeting.lead_uuid, full_name: this.update_meeting.name}
        }
        this.getCurrentPosition();
    })
    .catch(err => {
      console.log(err)
    })
  },
  methods: {
    suggestBroker(event) {
      if (event.length === 4) {
        event = encodeURIComponent(event)
        this.$axios.get(`/meetings/broker_info?name=${event.trim()}`)
          .then(res => {
            this.propertyNoInput = "No Results!"
            if (res.data.leads.length > 0) {
              this.brokerList = res.data.leads
            }
          })
          .catch(err => {
            this.propertyNoInput = "Something Went Wrong!"
          })
      }
    },
    getCurrentPosition() {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition((position) => {
                this.update_meeting.meeting_executive_lat = position.coords.latitude;
                this.update_meeting.meeting_executive_long = position.coords.longitude;
                this.getStreetAddressFrom(position.coords.latitude, position.coords.longitude);
            }, (error) => {
                console.log(error);
            }, { timeout: 10000, enableHighAccuracy: true, maximumAge: 0 });
        } else {
            //Geolocation is not supported by this browser
            console.log('Geolocation is not supported by this browser');
        }
    },
      async getStreetAddressFrom(lat, long) {
        var self = this;
        try {
            const { data } = await self.$axios.get(
                "https://maps.googleapis.com/maps/api/geocode/json?latlng=" +
                lat +
                "," +
                long +
                "&key=AIzaSyCDi6loOYUz1fXzMJpqI_83UlcdPrp86Fg"
            );
            if (data.error_message) {
                console.log(data.error_message)
            } else {
                this.update_meeting.location = data.results[0].formatted_address;
            }
        } catch (error) {
            console.log(error);
        }
      },
    uploadQuestionare() {
      this.update_meeting.attachment = event.target.files[0];
    },
    updateMeeting() {
      this.update_meeting.executive_image = this.$refs.cameraCapture.finalImage;
      console.log(this.update_meeting.executive_image)
      if(!this.update_meeting.executive_image){
          this.$refs.cameraCapture.checkPhoto = true;
          return;
      }else{
          this.$refs.cameraCapture.checkPhoto = false;
      }
      let apiParams = decodeMeetingParams(this.update_meeting);
      this.$axios
    .put(`meetings/${this.update_meeting.uuid}`, apiParams,{
      headers:{'Content-Type': 'multipart/form-data'}
    })
    .then((res) => {
        this.$refs.cameraCapture.stopCameraStream();
        swal({
            title: "Meeting Updated!",
            icon: "success",
        }).then(this.$router.replace({ name: 'MeetingDetails', params: { id: this.update_meeting.uuid } }));
    })
    .catch((err) => {
        if (err.response.status === 500) {
            swal({
                title: "Server Error!",
                icon: "error",
            });
        } else {
            swal({
                title: "Error",
                text: err.response.data.message,
                icon: "error",
            });
        }
    });
    },
  },
  computed: {
    localityList() {
      return this.$store.getters.localitiesMaster;
    },
    statusList() {
      return this.$store.getters.statusesMaster;
    },
    validationMsg(){
      return validationMessage(formMessages);
    }
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css">
</style>
<style  scoped>
label {
  letter-spacing: 0.01em;
  font-size: 14px;
  font-weight: 500;
}
.form-control {
  font-size: 14px;
}
</style>